export default {
  titles: {
    listOld: 'Listagem de faturas antigas',
    oldLimit: '* Apenas se mostrarão faturas cuja data de assinatura seja maior de 5 anos.',
    list: 'Listagem de faturas',
    payList: 'Listagem de faturas a pagar',
    financing: 'Listagem de faturas para financiamento',
    asProviderList: {
      enviadas: 'Listagem de faturas enviadas',
      aceptadas: 'Listagem de faturas aceites',
      rechazadas: 'Listagem de faturas recusadas'
    },
    asPayerList: {
      pendientes: 'Listagem de faturas pendentes de tratar',
      tratadas: 'Listagem de faturas tratadas'
    }
  },
  sejarcher: 'Buscador',
  rectified: {
    find: {
      seeRectified: 'Ver retificada',
      seeRectifying: 'Ver retificativa'
    },
    errors: {
      rectifyingNotFound: 'Factura retificativa gerada e eliminada pelo usuário antes de emiti-la.'
    }
  },
  result: {
    true: 'Correta',
    false: 'Rejeitada'
  },
  confirm: {
    acceptProFormPayer: {
      title: 'Aceitar pro formas como fornecedor',
      selection: ' Não selecionou pro formas. | Selecionou {0} pro forma por um total de {1} para tramitar no expediente selecionado. | Selecionou {0} pro formas por um total de {1} para tramitar no expediente selecionado.',
      continue: 'Deseja aceitar as pro formas selecionadas?'
    },
    financeables: {
      title: 'Resumo Financiamento',
      selection: ' Não selecionou faturas. | Selecionou {0} fatura por um total de {1} para tramitar: | Selecionou {0} faturas por um total de {1} para tramitar:',
      selectionBankia: ' Não selecionou faturas. | Selecionou {0} fatura por um total de {1} para tramitar no expediente selecionado: | Selecionou {0} faturas por um total de {1} para tramitar no expediente selecionado:',
      continue: 'Deseja continuar com a solicitação de financiamento?',
      errorDiscount: 'Não pode solicitar Desconto se já solicitou financiamento sobre alguma das faturas selecionadas',
      errorFactoring: 'Não pode solicitar financiamento se já solicitou Desconto sobre alguma das faturas selecionadas',
      info: 'O acesso ao serviço é feito através de uma janela pop-up. Se não conseguir entrar corretamente, lembre-se de verificar se esses elementos estão bloqueados pelo seu navegador.',
      doubt: 'Para qualquer dúvida sobre sua solicitação, entre em contato com sua financeira'
    },
    acceptBilling: {
      title: 'Listagem de faturas selecionadas para aceitar',
      selection: ' Não selecionou faturas. | Selecionou {0} fatura por um total de {1} para aceitar. | Selecionou {0} faturas por um total de {1} para aceitar.',
      continue: 'Deseja aceitar as faturas selecionadas?'
    },
    rejectProFormPayer: {
      title: 'Listagem de pro formas selecionadas para rejeitar',
      selection: ' Não selecionou pro formas. | Selecionou {0} pro forma por um total de {1} para rejeitar. | Selecionou {0} pro formas por um total de {1} para rejeitar.',
      continue: 'Deseja rejeitar as pro formas selecionadas?',
      text: 'Por favor, indique o motivo da rejeição'
    },
    rejectBilling: {
      title: 'Listagem de faturas selecionadas para rejeitar',
      selection: ' Não selecionou faturas. | Selecionou {0} fatura por um total de {1} para rejeitar. | Selecionou {0} faturas por um total de {1} para rejeitar.',
      continue: 'Deseja rejeitar as faturas selecionadas?',
      text: 'Por favor, indique o motivo da rejeição'
    },
    unrejectBilling: {
      title: 'Listagem de faturas selecionadas para ser des-rejeitadas',
      selection: ' Não selecionou faturas. | Selecionou {0} fatura por um total de {1} para des-rejeitar. | Selecionou {0} faturas por um total de {1} para des-rejeitar.',
      continue: 'Deseja des-rejeitar as faturas selecionadas?',
      text: 'Por favor, indique o motivo da des-rejeição'
    },
    acceptSelfBilling: {
      title: 'Listagem de faturas selecionadas para serem aceites',
      selection: ' Não selecionou faturas. | Selecionou {0} fatura por um total de {1} para aceitar. | Selecionou {0} faturas por um total de {1} para aceitar.',
      continue: 'Deseja aceitar faturas das faturas selecionadas?'
    },
    rejectSelfBilling: {
      title: 'Listagem de faturas selecionadas para serem rejeitadas',
      selection: ' Não selecionou faturas. | Selecionou {0} fatura por um total de {1} para rejeitar. | Selecionou {0} faturas por um total de {1} para rejeitar.',
      continue: 'Deseja rejeitar as faturas selecionadas?',
      text: 'Por favor, indique o motivo da rejeição'
    },
    cancelInvoice: {
      title: 'Listagem de faturas selecionadas para solicitar sua anulação',
      selection: ' Não selecionou faturas. | Selecionou {0} fatura por um total de {1} para solicitar anulação. | Selecionou {0} faturas por um total de {1} para solicitar anulação.',
      continue: 'Deseja solicitar a anulação das faturas selecionadas?',
      text: 'Indique o motivo da anulação'
    },
    acceptCancel: {
      title: 'Listagem de faturas selecionadas para aceitar sua anulação',
      selection: ' Não selecionou faturas. | Selecionou {0} fatura por um total de {1} para aceitar sua anulação. | Selecionou {0} faturas por um total de {1} para aceitar sua anulação.',
      continue: 'Deseja aceitar a anulação das faturas selecionadas?',
      text: 'Indique o motivo de aceitação da anulação',
      error: 'Para aceitar a anulação de uma fatura, previamente deve-se solicitar a anulação por parte do fornecedor'
    },
    rejectCancel: {
      title: 'Listagem de faturas selecionadas para rejeitar sua anulação',
      selection: ' Não selecionou faturas. | Selecionou {0} fatura por um total de {1} para rejeitar sua anulação. | Selecionou {0} faturas por um total de {1} para rejeitar sua anulação.',
      continue: 'Deseja rejeitar a anulação das faturas selecionadas?',
      text: 'Indique o motivo da rejeição da anulação',
      error: 'Para rejeitar a anulação de uma fatura, previamente deve-se solicitar a anulação por parte do fornecedor'
    },
    issue: {
      title: 'Listagem de faturas selecionadas para emitir',
      selection: ' Não selecionou faturas. | Selecionou {0} fatura por um total de {1} para emitir. | Selecionou {0} faturas por um total de {1} para emitir.',
      info: '',
      continue: 'Deseja emitir as faturas selecionadas?'
    },
    issueProFromPayer: {
      title: 'Listagem de pro formas selecionadas para emitir',
      selection: ' Não selecionou pro formas. | Selecionou {0} pro forma por um total de {1} para emitir. | Selecionou {0} pro formas por um total de {1} para emitir.',
      continue: 'Deseja emitir as pro formas selecionadas?'
    },
    issueSelf: {
      title: 'Listagem de autofaturas selecionadas para emitir',
      selection: ' Não selecionou autofaturas. | Selecionou {0} autofatura por um total de {1} para emitir. | Selecionou {0} autofaturas por um total de {1} para emitir.',
      continue: 'Deseja emitir as autofaturas selecionadas?'
    },
    issueproforma: {
      title: 'Listagem de faturas selecionadas para enviar pro formas',
      selection: ' Não selecionou faturas. | Selecionou {0} fatura por um total de {1} para enviar pro forma. | Selecionou {0} faturas por um total de {1} para enviar pro formas.',
      continue: 'Deseja enviar pro formas das faturas selecionadas?'
    },
    issueproformaSelf: {
      title: 'Listagem de autofaturas selecionadas para enviar pro formas',
      selection: ' Não selecionou autofaturas. | Selecionou {0} autofatura por um total de {1} para enviar pro forma. | Selecionou {0} autofaturas por um total de {1} para enviar pro formas.',
      continue: 'Deseja enviar pro formas das autofaturas selecionadas?'
    },
    send: {
      title: 'Listagem de faturas selecionadas para enviar',
      selection: ' Não selecionou faturas. | Selecionou {0} fatura por um total de {1} para enviar. | Selecionou {0} faturas por um total de {1} para enviar.',
      info: {
        contractReference: 'A fatura de terceiros {1} não inclui a "Referência de Contrato" (ex: T123456) de caráter geralmente obrigatório para Bankia. Em faturas inseridas manualmente, este dado deve ser coletado na seção "Dados do gestor". | As faturas de terceiros {1} não incluem a "Referência de Contrato" (ex: T123456) de caráter geralmente obrigatório para Bankia. Em faturas inseridas manualmente, este dado deve ser coletado na seção "Dados do gestor".',
        fixField: 'Se desejar, ainda pode cancelar o processo de emissão/envio para incluir este dado na fatura.'
      },
      continue: 'Deseja enviar as faturas selecionadas?'
    },
    remove: {
      title: 'Listagem de faturas selecionadas para eliminar',
      selection: ' Não selecionou faturas. | Selecionou {0} fatura por um total de {1} para eliminar. | Selecionou {0} faturas por um total de {1} para eliminar.',
      continue: 'Deseja eliminar as faturas selecionadas?'
    },
    deleteProFormProvider: {
      title: 'Listagem de pro formas selecionadas para eliminar',
      selection: ' Não selecionou pro formas. | Selecionou {0} pro forma por um total de {1} para eliminar. | Selecionou {0} pro formas por um total de {1} para eliminar.',
      continue: 'Deseja eliminar as pro formas selecionadas?'
    },
    removeSelf: {
      title: 'Listagem de autofaturas selecionadas para eliminar',
      selection: ' Não selecionou autofaturas. | Selecionou {0} autofatura por um total de {1} para eliminar. | Selecionou {0} autofaturas por um total de {1} para eliminar.',
      continue: 'Deseja eliminar as autofaturas selecionadas?'
    }
  },
  headers: {
    created: 'F. criação',
    issue: 'F. emissão',
    id: 'Série - Número',
    provider: 'Fornecedor',
    client: 'Cliente',
    status: 'Estado',
    type: 'Tipo',
    serie: 'Série',
    number: 'Número',
    amount: 'Importe',
    result: 'Resultado',
    comments: 'Comentários',
    invoiceId: 'Identificador fiscal',
    format: 'Formato'
  },
  csv: {
    invoiceId: 'Identificador fiscal',
    createDate: 'data criação',
    incomeDate: 'data devengo',
    issueDate: 'data emissão',
    provider: {
      name: 'Nome fornecedor',
      document: 'NIF fornecedor'
    },
	agent: {
      name: 'Nome gestor',
      document: 'NIF gestor'
    },
    client: {
      name: 'Nome cliente',
      document: 'NIF cliente'
    },
    status: 'Estado',
type: 'Tipo',
taxableAmount: 'Base tributável',
taxes: 'Total impostos',
amount: 'Importe total'
},
filter: {
  byCreated: 'data de criação',
  byIssued: 'data de emissão',
  from: 'De',
  to: 'Até',
  byId: 'Série e número',
  bySerie: 'Série',
  byNumber: 'Número',
  byStatus: 'Estado',
  byDocument: 'Documento',
  byProviderDocument: 'NIF/CIF/NIE Fornecedor',
  byClientDocument: 'NIF/CIF/NIE Cliente',
  byAmount: 'Importe (€)',
  delegations: 'Delegações',
  days: 'Dias',
  months: 'Meses',
  years: 'Anos',
  other: 'Outros'
},
download: {
  asCSV: 'Descarregar CSV',
  asPDF: 'Descarregar em PDF'
},
helps: {
  type: 'No tipo de fatura (A) indica fatura de Abono e (R) retificativa.'
},
actions: {
  acceptSelfBilling: 'Aceitar autofaturas',
  rejectSelfBilling: 'Rejeitar autofaturas',
  acceptBilling: 'Aceitar faturas',
  rejectBilling: 'Rejeitar faturas',
  unrejectBilling: 'Des-rejeitar faturas',
  financing: 'Solicitar financiamento',
  acceptFinancing: 'Aceitar condições',
  cancelInvoice: 'Anular faturas',
  acceptCancellation: 'Aceitar cancelamento',
  rejectCancellation: 'Rejeitar cancelamento'
},
types: {
  1: 'Fatura',
  4: 'Autofatura'
},
subtypes: {
  payment: ' (A)',
  rectify: ' (R)'
},
financing: {
  nif: 'N.I.F.',
  name: 'Nome',
  surname: 'Sobrenome',
  phone: 'Telefone móvel',
  email: 'Email de contato',
  iban: 'IBAN',
  error: 'A operação não foi executada corretamente, por favor, tente novamente.',
  popup: 'Por favor, se deseja continuar com a operação deve desativar o bloqueio de pop-ups.',
  errorMessages: {
    notExpedients: 'Para solicitar o adiantamento de faturas deve ter contratado o serviço de financiamento',
    notGeneralModule: 'Para solicitar o adiantamento de faturas através de financiamento deve ter contratado o módulo geral da Oficina Internet de Empresas com envio de arquivos em Formato Livre.',
    notExpedientsNorGeneralModule: 'Para solicitar o adiantamento de faturas deve ter contratado o módulo geral da Oficina Internet de Empresas com envio de arquivos em Formato Livre e o serviço de financiamento.'
  },
  popFinanceables: {
    wait: 'Aguarde um momento, por favor.',
    access: 'Acessando o serviço de financiamento...'
  },
  signValidation: 'Digite sua chave de assinatura para continuar com a operação.',
  simulation: {
    simulate: 'Simular Financiamento',
    loading: 'Calculando o financiamento. Por favor, aguarde...',
    result: 'Resultado da simulação de financiamento:',
    final: 'Liquido Final:',
    retention: 'Retenção de Importe:',
    fee: 'Juros e Comissão:',
    question: 'Deseja realizar uma simulação de financiamento?'
  },
  tooltip: {
    nif: 'DNI do administrador ou representante da empresa <br> Para autônomos: NIF',
    phone: 'Obrigatório para enviar o contrato por SMS',
    iban: 'Conta IBAN que aparecerá no contrato'
  }
},
issue: {
  errors: {
    tryAgain: 'Sua fatura foi salva com sucesso, mas ocorreu um problema durante a emissão. Tente emitir novamente a partir da Listagem ou edite-a novamente.',
    maxInvoicesIssued: 'Não é permitido emitir mais de {0} faturas com uma conta gratuita | Já foram emitidas {0} faturas, então, apenas podem ser emitidas {1} faturas adicionais com uma conta gratuita. | Você atingiu o limite de faturas emitidas no ano. Faça upgrade para a conta PRO e aproveite todas as vantagens que este serviço oferece.',
    freeAccount: 'Conta Gratuita',
    maxInvoicesIssuedModal: 'Você atingiu o limite de faturas emitidas no ano. Faça upgrade para a conta PRO e aproveite todas as vantagens que este serviço oferece.'
  }
},
save: {
  errors: {
    maxAmount: 'O valor total da fatura excede o máximo permitido (99.999.999,00 EUR)',
    maxSize: 'O limite (8192 Kbytes) foi excedido para os arquivos anexados a uma fatura.',
    dir3Info: 'Ao selecionar um contato com Dir3, é obrigatório preencher os tipos: Escritório Contábil, Órgão Gestor e Unidade Tramitadora'
  }
},
validations: {
  drafts: {
    noContractReference: 'A fatura não inclui a \'Referência de Contrato\' (ex: T123456) geralmente obrigatória para Bankia. Em faturas inseridas manualmente, este dado deve ser recolhido na seção "Dados do Fornecedor" (Dados Gerais). Se desejar, ainda pode cancelar o processo de emissão/envio para incluir esta referência na fatura.'
  },
  autodrafts: {
    noContractReference: 'A autofatura não inclui a \'Referência de Contrato\' (ex: T123456) geralmente obrigatória para Bankia. Em faturas inseridas manualmente, este dado deve ser recolhido na seção "Dados do Fornecedor" (Dados Gerais). Se desejar, ainda pode cancelar o processo de emissão/envio para incluir esta referência na fatura.'
  },
  thirdPartyDrafts: {
    noContractReference: 'A fatura de terceiros não inclui a \'Referência de Contrato\' (ex: T123456) geralmente obrigatória para Bankia. Em faturas inseridas manualmente, este dado deve ser recolhido na seção "Dados do Gestor" (Dados Gerais). Se desejar, ainda pode cancelar o processo de emissão/envio para incluir esta referência na fatura.'
  }
}
}
